import { AxiosPromise, AxiosResponse } from 'axios';

import { readAdminMe } from './auditorsWire';
import { mmHttp, MmRequestConfig } from './mmHttp';
import { getSpBackendUrlForExchange } from '../config/env';
import { getSpAccessToken } from '../core/spSession';
import { MmSessionExchangeRequest, MmSessionExchangeResponse } from '../types/dto';
import { MmAdminMe, MmSessionToken } from '../types/domain';

/** Префикс /api/admin/v1 здесь не пишем: он подставляется как базовый путь, иначе путь удвоится */
export const MM_SESSION_EXCHANGE_PATH = '/auth/exchange';

/** Короче общего таймаута намеренно: обмен блокирует раздел, нужен быстрый отказ */
export const MM_SESSION_EXCHANGE_TIMEOUT_MS = 12000;

export const MM_ADMIN_ME_PATH = '/me';

/** Ответ обмена несёт только accessToken: срока жизни в нём нет, берём его из самого токена */
function readTokenFromBody(body: any): MmSessionExchangeResponse | null {
  if (!body || typeof body !== 'object') {
    return null;
  }

  const candidates = ['accessToken', 'access_token', 'token', 'mobileToken'];
  let accessToken: string | null = null;

  for (let i = 0; i < candidates.length; i += 1) {
    const value = body[candidates[i]];

    if (typeof value === 'string' && value !== '') {
      accessToken = value;
      break;
    }
  }

  if (accessToken === null) {
    return null;
  }

  const expiresRaw = body.expiresIn !== undefined ? body.expiresIn : body.expires_in;
  const expiresIn = typeof expiresRaw === 'number' ? expiresRaw : null;
  const tokenType = typeof body.tokenType === 'string' ? body.tokenType : null;

  return {
    accessToken: accessToken,
    expiresIn: expiresIn,
    tokenType: tokenType,
  };
}

export class MmNoSpSessionError extends Error {
  public readonly mmNoSpSession = true;

  constructor() {
    super('SmartPricing session is not available');

    // TypeScript 3.4.1: цепочку прототипов наследника Error восстанавливаем вручную ради `instanceof`
    Object.setPrototypeOf(this, MmNoSpSessionError.prototype);
  }
}

export function isNoSpSessionError(error: any): boolean {
  return !!(error && error.mmNoSpSession === true);
}

/** У самого обмена мобильного токена ещё нет: подставлять протухший в заголовок нельзя */
export async function exchangeSession(tradingNetworkId: number): Promise<MmSessionToken> {
  const spAccessToken = getSpAccessToken();

  if (spAccessToken === null) {
    throw new MmNoSpSessionError();
  }

  const spBackendUrl = getSpBackendUrlForExchange();

  /** Тело несёт оба набора имён: часть стендов ещё ждёт старые ключи, удалять их нельзя */
  const payload: MmSessionExchangeRequest = {
    spAccessToken: spAccessToken,

    spBaseUrl: spBackendUrl,
    tradingId: tradingNetworkId,

    spBackendUrl: spBackendUrl,
    tradingNetworkId: tradingNetworkId,
  };

  const config: MmRequestConfig = {
    mmSkipAuth: true,
    mmSection: 'session-exchange',
    /** Обмен идёт без повторов: повторять его нельзя */
    mmNoRetry: true,
    timeout: MM_SESSION_EXCHANGE_TIMEOUT_MS,
  };

  const response: AxiosResponse = await mmHttp.post(MM_SESSION_EXCHANGE_PATH, payload, config);
  const parsed = readTokenFromBody(response.data);

  if (parsed === null) {
    const error = new Error('Session exchange response contains no access token');

    (error as any).response = response;
    (error as any).config = response.config;

    throw error;
  }

  return {
    accessToken: parsed.accessToken,
    tradingNetworkId: tradingNetworkId,
    obtainedAt: Date.now(),
    expiresInSeconds: parsed.expiresIn,
  };
}

export function fetchAdminMe(config?: MmRequestConfig): AxiosPromise<MmAdminMe> {
  return mmHttp
    .get(MM_ADMIN_ME_PATH, Object.assign({ mmSection: 'admin/me' }, config))
    .then((response: AxiosResponse) => {
      response.data = readAdminMe(response.data);

      return response;
    });
}
